import React, { useCallback, useEffect, useState } from "react";
import "../../../Assets/CSS/bulkorder.css";
import "../oms.css";
import { Document, Page } from "react-pdf";
import { pdfjs } from "react-pdf";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import Up from "../../../Assets/Images/OMS/up.svg";
import Down from "../../../Assets/Images/OMS/down.svg";
import Loading from "../../../Assets/Images/OMS_New/loading.svg";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { useFormik } from "formik";
import CloseIcon from "@material-ui/icons/Close";
import IconButton from "@material-ui/core/IconButton";
import { Box, Button, Card, Modal } from "@mui/material";

import AddLoadingDetails from "../AddLoadingDetails";

import axios from "axios";
import toast from "react-hot-toast";
import moment from "moment";
import UploadDocs from "../common/uploadDocs";
import ShowPDF from "../common/pdfViewer";
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;
function LoadingDetailsSupplierForm({ orderId, omsData, getOMSData }) {
  const isPending =
    omsData?.only_bnps?.ayekart_lvl1_status !== "Approved" ||
    omsData?.only_bnps?.ayekart_lvl2_status !== "Approved";

  const [open, setOpen] = React.useState(false);
  const [openDoc, setOpenDoc] = useState(false);
  const handleOpenDoc = () => {
    setOpenDoc(true);
  };
  const handleCloseDoc = () => setOpenDoc(false);
  const [supplierDoc, setSupplierDoc] = useState([]);
  const addObject = (newObject) => {
    setSupplierDoc([...supplierDoc, newObject]);
  };
  const handleAddObject = (newObject) => {
    addObject(newObject);
  };
  const handleClose = () => setOpen(false);

  const calculateNetWeight = () => {
    const grossWeight = formik.values.gross_weight || 0;
    const bardana = formik.values.bardana || 0;
    const bags = formik.values.no_of_gunny_bags || 0;
    const netWeight = grossWeight - (bardana * bags) / 100;
    formik.setFieldValue("net_weight", netWeight);
  };

  const calculateGrossWeight = () => {
    const totalWeight = formik.values.total_weight || 0;
    const tareWeight = formik.values.tare_weight || 0;
    const grossWeight = totalWeight - tareWeight;
    formik.setFieldValue("gross_weight", grossWeight);
  };

  const calculateTotalAmount = () => {
    const quantity =
      parseFloat(omsData?.op_sourcing_details?.[0]?.quantity) || 0;
    const gstAmount =
      parseFloat(omsData?.op_sourcing_details?.[0]?.gst_amount) || 0;
    const unitPrice =
      parseFloat(formik.values.purchase_price_from_retailer) || 0;
    const totalAmount = unitPrice * quantity + gstAmount;

    formik.setFieldValue("total_price_for_commodity", totalAmount);
  };

  const bagOptions = [
    { label: "Jute", value: "jute" },
    { label: "Nylon", value: "nylon" },
    { label: "Bopp", value: "bopp" },
    { label: "Poly Bag", value: "polybag" },
  ];

  const [supplierLoading, setSupplierLoading] = useState(false);

  const validate = (values) => {
    const errors = {};
    if (!values.total_weight) {
      errors.total_weight = "Total Weight is Required";
    }
    if (!values.tare_weight) {
      errors.tare_weight = "Tare Weight is Required";
    }
    if (!values.purchase_price_from_retailer) {
      errors.purchase_price_from_retailer = "Purchase Price is Required";
    }

    if (!values.packaging_bag_type) {
      errors.packaging_bag_type = "Packaging Bag Type is Required";
    }

    if (!values.no_of_gunny_bags) {
      errors.no_of_gunny_bags = "Number of Bags is Required";
    }
    // if(!values.bag_cost){
    //   errors.bag_cost = "Bag Cost is Required";
    // }

    return errors;
  };
  const [pdfUrl, setPdfUrl] = useState("");
  const [activeModal, setActiveModal] = useState(false);
  const initialValues = {
    total_weight: null,
    gross_weight: 0,
    tare_weight: null,
    net_weight: 0,
    purchase_price_from_retailer: null,
    total_price_for_commodity: 0,
    packaging_bag_type: null,
    no_of_gunny_bags: null,
    bag_cost: null,
    bages_weights: null,
    supplier_loading_time: null,
    loading_attachments: null,
    loading_cost: "",
    loading_wages: "",
    bardana: "",
    cash_discount: "",
  };

  const handleSubmit = async (values) => {
    const actioner = JSON.parse(localStorage.getItem("user_detail"));

    const payload = {
      order_id: orderId,
      supplier_loading: true,
      supplier_loading_time: moment(new Date()).format("YYYY-MM-DD"),
      supplier_loading_actioner: actioner?.user_name
        ? actioner?.user_name
        : null,
      supplier_total_weight: values.total_weight ? values.total_weight : null,
      supplier_gross_weight: values.gross_weight ? values.gross_weight : null,
      supplier_tare_weight: values.tare_weight ? values.tare_weight : null,
      supplier_packaging_bag_type: values.packaging_bag_type
        ? values.packaging_bag_type
        : null,
      supplier_no_of_gunny_bags: values.no_of_gunny_bags
        ? values.no_of_gunny_bags
        : null,
      supplier_cost_per_bag: values.bag_cost ? values.bag_cost : null,
      bages_weights: values?.bages_weights ? values?.bages_weights : null,
      supplier_loading_time: values?.supplier_loading_time
        ? values?.supplier_loading_time
        : null,
      purchase_price_from_retailer: values.purchase_price_from_retailer
        ? values.purchase_price_from_retailer
        : null,
      supplier_total_commodity_price: values.total_price_for_commodity
        ? values.total_price_for_commodity
        : null,
      supplier_net_weight: values.net_weight || null,
      loading_attachments: omsData?.loading_attachments
        ? [...omsData?.loading_attachments, ...supplierDoc]
        : [...supplierDoc],
      loading_cost: values.loading_cost || null,
      loading_wages: values.loading_wages || null,
      bardana: values.bardana || null,
      cash_discount: values.cash_discount || null,
    };

    try {
      const { data } = await axios.patch("/api/orders/update", payload);
      if (data.status) {
        formik.resetForm();
        getOMSData();
        toast.success(data.message);
      } else {
        toast.error(data.message);
      }
    } catch (error) {
      console.log(error);
      toast.error(error);
    }
  };

  const formik = useFormik({
    initialValues: initialValues,
    validate,
    onSubmit: handleSubmit,
  });

  useEffect(() => {
    calculateNetWeight();
  }, [
    formik.values.gross_weight,
    formik.values.bardana,
    formik.values.no_of_gunny_bags,
  ]);

  useEffect(() => {
    calculateGrossWeight();
  }, [formik.values.total_weight, formik.values.tare_weight]);

  useEffect(() => {
    calculateTotalAmount();
  }, [formik.values.purchase_price_from_retailer, omsData]);

  useEffect(() => {
    formik.setValues({
      ...formik.values,
      gross_weight: omsData?.supplier_gross_weight
        ? omsData?.supplier_gross_weight
        : "",
      total_weight: omsData?.supplier_total_weight
        ? omsData?.supplier_total_weight
        : "",
      tare_weight: omsData?.supplier_tare_weight
        ? omsData?.supplier_tare_weight
        : "",
      purchase_price_from_retailer: omsData?.purchase_price_from_retailer
        ? omsData?.purchase_price_from_retailer
        : "",
      total_price_for_commodity: omsData?.supplier_total_commodity_price
        ? omsData?.supplier_total_commodity_price
        : "",
      packaging_bag_type: omsData?.supplier_packaging_bag_type
        ? omsData?.supplier_packaging_bag_type
        : "",
      no_of_gunny_bags: omsData?.supplier_no_of_gunny_bags
        ? omsData?.supplier_no_of_gunny_bags
        : "",
      bag_cost: omsData?.supplier_cost_per_bag
        ? omsData?.supplier_cost_per_bag
        : "",
      bages_weights: omsData?.bages_weights ? omsData?.bages_weights : 0,
      supplier_loading_time: omsData?.supplier_loading_time
        ? omsData?.supplier_loading_time
        : null,
      net_weight: omsData?.supplier_net_weight || 0,
      loading_cost: omsData?.loading_cost || "",
      loading_wages: omsData?.loading_wages || "",
      bardana: omsData?.bardana || "",
      cash_discount: omsData?.cash_discount || "",
    });
  }, [omsData, formik.setValues]);

  // ------------------ view doc ----------------------------------------------------------

  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);
  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
  }

  function changePage(offset) {
    setPageNumber((prevPageNumber) => prevPageNumber + offset);
  }

  function previousPage() {
    changePage(-1);
  }

  function nextPage() {
    changePage(1);
  }

  // ------------------------------------ View pdf files -----------------------------------------------
  const handleModalClose = () => {
    setPdfUrl("");
    setActiveModal(false);
  };

  const handleModalOpen = (pdfUrl) => {
    setPdfUrl(pdfUrl);
    setActiveModal(true);
  };

  return (
    <div className="">
      <div className="shadow-lg m-2 p-2 pb-2 rounded-lg">
        <div className="flex flex-col sm:flex-row justify-between">
          <div className="font-medium text-cyan-950 text-md flex gap-1">
            <img src={Loading} alt="" />
            <div className="ms-1"> Loading Details</div>
            {/*<Button className="m-0 p-0" onClick={() => handleOpen()}>
                <img src={AddMore} alt="" />
              </Button>*/}
          </div>
          <div>
            {supplierLoading ? (
              <div className="font-medium text-cyan-950 text-lg mt-2">
                <img
                  src={Up}
                  alt=""
                  role="button"
                  onClick={() => setSupplierLoading(!supplierLoading)}
                />
              </div>
            ) : (
              <div className="font-medium text-cyan-950 text-lg mt-2">
                <img
                  src={Down}
                  alt=""
                  role="button"
                  onClick={() => setSupplierLoading(!supplierLoading)}
                />
              </div>
            )}
          </div>
        </div>
        <div>
          <hr className="font-bold text-neutral-500 bg-gray-900 h-0.5" />
        </div>
        <div>
          {supplierLoading ? (
            <></>
          ) : (
            <div>
              <form onSubmit={formik.handleSubmit}>
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-2">
                  <div>
                    <label
                      for="total_weight"
                      className="block mb-2 text-sm font-medium text-blue-900 dark:text-white flex justify-start ms-1"
                    >
                      Total Weight in Qtl
                    </label>
                    <input
                      type="number" onWheel={(e) => e.target.blur()}
                      min={0}
                      id="total_weight"
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      name="total_weight"
                      placeholder="Enter Total Weight"
                      value={formik.values.total_weight}
                      onChange={formik.handleChange}
                      step="any"
                      disabled={isPending}
                    />
                    {formik.errors.total_weight &&
                    formik.touched.total_weight ? (
                      <div className="text-red-600 text-sm flex justify-start ms-1">
                        {formik.errors.total_weight}
                      </div>
                    ) : null}
                  </div>
                  <div>
                    <label
                      for="tare_weight"
                      className="block mb-2 text-sm font-medium text-blue-900 dark:text-white flex justify-start ms-1"
                    >
                      Tare Weight in Qtl
                    </label>
                    <input
                      type="number" onWheel={(e) => e.target.blur()}
                      min={0}
                      id="tare_weight"
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      name="tare_weight"
                      placeholder="Enter Tare Weight"
                      value={formik.values.tare_weight}
                      onChange={formik.handleChange}
                      step="any"
                      disabled={isPending}
                    />
                    {formik.errors.tare_weight && formik.touched.tare_weight ? (
                      <div className="text-red-600 text-sm flex justify-start ms-1">
                        {formik.errors.tare_weight}
                      </div>
                    ) : null}
                  </div>
                  <div>
                    <label
                      for="gross_weight"
                      className="block mb-2 text-sm font-medium text-blue-900 dark:text-white flex justify-start ms-1"
                    >
                      Gross Weight in Qtl
                    </label>
                    <input
                      type="number" onWheel={(e) => e.target.blur()}
                      min={0}
                      id="gross_weight"
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      name="gross_weight"
                      placeholder="Enter Gross Weight"
                      value={formik.values.gross_weight}
                      onChange={formik.handleChange}
                      step="any"
                      disabled
                    />
                    {formik.errors.gross_weight &&
                    formik.touched.gross_weight ? (
                      <div className="text-red-600 text-sm flex justify-start ms-1">
                        {formik.errors.gross_weight}
                      </div>
                    ) : null}
                  </div>
                  <div>
                    <label
                      for="bardana"
                      className="block mb-2 text-sm font-medium text-blue-900 dark:text-white flex justify-start ms-1"
                    >
                      Bardana (Kg)
                    </label>

                    <input
                      type="number" onWheel={(e) => e.target.blur()}
                      min={0}
                      id="bardana"
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      name="bardana"
                      placeholder="Enter Bardana"
                      value={formik.values.bardana}
                      onChange={formik.handleChange}
                      step="any"
                    />
                    {formik.errors.bardana ? (
                      <div className="text-red-600 text-sm">
                        {formik.errors.bardana}
                      </div>
                    ) : null}
                  </div>
                  <div>
                    <label
                      for="net_weight"
                      className="block mb-2 text-sm font-medium text-blue-900 dark:text-white flex justify-start ms-1"
                    >
                      Net Weight in Qtl
                    </label>
                    <input
                      type="number" onWheel={(e) => e.target.blur()}
                      min={0}
                      id="net_weight"
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      name="net_weight"
                      disabled
                      value={formik.values.net_weight}
                      onChange={formik.handleChange}
                      step="any"
                    />
                    {formik.errors.net_weight ? (
                      <div className="text-red-600 text-sm flex justify-start ms-1">
                        {formik.errors.net_weight}
                      </div>
                    ) : null}
                  </div>
                  <div>
                    <label
                      for="purchase_price_from_retailer"
                      className="block mb-2 text-sm font-medium text-blue-900 dark:text-white flex justify-start ms-1"
                    >
                      Purchase price (per Quintal)
                    </label>

                    <input
                      type="number" onWheel={(e) => e.target.blur()}
                      min={0}
                      id="purchase_price_from_retailer"
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      name="purchase_price_from_retailer"
                      placeholder="Purchase price (per Quintal)"
                      value={formik.values.purchase_price_from_retailer}
                      onChange={formik.handleChange}
                      step="any"
                      disabled={isPending}
                    />
                    {formik.errors.purchase_price_from_retailer &&
                    formik.touched.purchase_price_from_retailer ? (
                      <div className="text-red-600 text-sm flex justify-start ms-1">
                        {formik.errors.purchase_price_from_retailer}
                      </div>
                    ) : null}
                  </div>
                  <div>
                    <label
                      for="total_price_for_commodity"
                      className="block mb-2 text-sm font-medium text-blue-900 dark:text-white flex justify-start ms-1"
                    >
                      Total Price For Commodity(Total CP)
                    </label>
                    <span class="absolute inset-y- left-0 flex items-center pl-2 text-gray-900 dark:text-white">
                      ₹
                    </span>
                    <input
                      type="number" onWheel={(e) => e.target.blur()}
                      min={0}
                      id="total_price_for_commodity"
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      name="total_price_for_commodity"
                      placeholder="Enter Purchase Price From Retailer(Rs)"
                      value={formik.values.total_price_for_commodity}
                      onChange={formik.handleChange}
                      step="any"
                      disabled={isPending}
                    />
                    {formik.errors.total_price_for_commodity &&
                    formik.touched.total_price_for_commodity ? (
                      <div className="text-red-600 text-sm flex justify-start ms-1">
                        {formik.errors.total_price_for_commodity}
                      </div>
                    ) : null}
                  </div>
                  <div className="mb-3">
                    <label className="block mb-2 text-sm font-medium text-blue-900 dark:text-white flex justify-start ms-1">
                      Packaging bag type
                    </label>
                    <select
                      value={formik.values.packaging_bag_type}
                      onChange={formik.handleChange}
                      name="packaging_bag_type"
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      disabled={isPending}
                    >
                      <option value="Select Expense">Select Option</option>
                      {bagOptions.map((each, index) => (
                        <option value={each.value} key={index}>
                          {each.label}
                        </option>
                      ))}
                    </select>
                    {formik.errors.packaging_bag_type &&
                    formik.touched.packaging_bag_type ? (
                      <div className="text-red-600 text-sm flex justify-start ms-1">
                        {formik.errors.packaging_bag_type}
                      </div>
                    ) : null}
                  </div>
                  <div>
                    <label
                      for="no_of_gunny_bags"
                      className="block mb-2 text-sm font-medium text-blue-900 dark:text-white flex justify-start ms-1"
                    >
                      Number of Bags / Crates / Boxes
                    </label>
                    <input
                      type="number" onWheel={(e) => e.target.blur()}
                      min={0}
                      id="no_of_gunny_bags"
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      name="no_of_gunny_bags"
                      placeholder="Enter Number of Bags"
                      value={formik.values.no_of_gunny_bags}
                      onChange={formik.handleChange}
                      step="any"
                      disabled={isPending}
                    />
                    {formik.errors.no_of_gunny_bags &&
                    formik.touched.no_of_gunny_bags ? (
                      <div className="text-red-600 text-sm flex justify-start ms-1">
                        {formik.errors.no_of_gunny_bags}
                      </div>
                    ) : null}
                  </div>
                  {/* --------------- New Fields ---------------------------------- */}
                  <div>
                    <label
                      for="bages_weights"
                      className="block mb-2 text-sm font-medium text-blue-900 dark:text-white flex justify-start ms-1"
                    >
                      Per Bag Weight
                    </label>
                    <input
                      type="number" onWheel={(e) => e.target.blur()}
                      min={0}
                      id="bages_weights"
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      name="bages_weights"
                      placeholder="Enter Number of Bags"
                      value={formik.values.bages_weights}
                      onChange={formik.handleChange}
                      step="any"
                      disabled={isPending}
                    />
                    {formik.errors.bages_weights &&
                    formik.touched.bages_weights ? (
                      <div className="text-red-600 text-sm flex justify-start ms-1">
                        {formik.errors.bages_weights}
                      </div>
                    ) : null}
                  </div>
                  <div>
                    <label
                      for="supplier_loading_time"
                      className="block mb-2 text-sm font-medium text-blue-900 dark:text-white flex justify-start ms-1"
                    >
                      Loading Date
                    </label>
                    {formik.values?.supplier_loading_time ? (
                      <input
                        id="supplier_loading_time"
                        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                        name="supplier_loading_time"
                        placeholder="Enter Loading Date"
                        value={
                          formik.values?.supplier_loading_time
                            ? new Date(
                                formik.values?.supplier_loading_time
                              ).toLocaleDateString()
                            : ""
                        }
                        disabled
                        // onChange={formik.handleChange}
                        step="any"
                      />
                    ) : (
                      <input
                        type="date"
                        id="supplier_loading_time"
                        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                        name="supplier_loading_time"
                        placeholder="Enter Loading Date"
                        value={
                          formik.values?.supplier_loading_time
                            ? formik.values?.supplier_loading_time
                            : ""
                        }
                        onChange={formik.handleChange}
                        step="any"
                        disabled={isPending}
                      />
                    )}

                    {formik.supplier_loading_time ? (
                      <div className="text-red-600 text-sm flex justify-start ms-1">
                        {formik.supplier_loading_time}
                      </div>
                    ) : null}
                  </div>
                  <div>
                    <label
                      for="loading_cost"
                      className="block mb-2 text-sm font-medium text-blue-900 dark:text-white flex justify-start ms-1"
                    >
                      Loading cost (Rs)
                    </label>
                    <input
                      type="number" onWheel={(e) => e.target.blur()}
                      min={0}
                      id="loading_cost"
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      name="loading_cost"
                      placeholder="Enter Loading Cost"
                      value={formik.values.loading_cost}
                      onChange={formik.handleChange}
                      step="any"
                      disabled={isPending}
                    />
                    {formik.errors.loading_cost &&
                    formik.touched.loading_cost ? (
                      <div className="text-red-600 text-sm flex justify-start ms-1">
                        {formik.errors.loading_cost}
                      </div>
                    ) : null}
                  </div>
                  <div>
                    <label
                      for="loading_wages"
                      className="block mb-2 text-sm font-medium text-blue-900 dark:text-white flex justify-start ms-1"
                    >
                      Wages (Rs)
                    </label>
                    <input
                      type="number" onWheel={(e) => e.target.blur()}
                      min={0}
                      id="loading_wages"
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      name="loading_wages"
                      placeholder="Enter Loading Wages"
                      value={formik.values.loading_wages}
                      onChange={formik.handleChange}
                      step="any"
                      disabled={isPending}
                    />
                    {formik.errors.loading_wages &&
                    formik.touched.loading_wages ? (
                      <div className="text-red-600 text-sm flex justify-start ms-1">
                        {formik.errors.loading_wages}
                      </div>
                    ) : null}
                  </div>
                  <div>
                    <label
                      for="cash_discount"
                      className="block mb-2 text-sm font-medium text-blue-900 dark:text-white flex justify-start ms-1"
                    >
                      Cash Discount (Rs)
                    </label>

                    <input
                      type="number" onWheel={(e) => e.target.blur()}
                      min={0}
                      id="cash_discount"
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      name="cash_discount"
                      placeholder="Enter Cash Discount"
                      value={formik.values.cash_discount}
                      onChange={formik.handleChange}
                      step="any"
                      disabled={isPending}
                    />
                    {formik.errors.cash_discount ? (
                      <div className="text-red-600 text-sm">
                        {formik.errors.cash_discount}
                      </div>
                    ) : null}
                  </div>
                </div>
                {omsData?.loading_attachments?.length > 0 ? (
                  <div className="flex justify-start mt-2">
                    {" "}
                    <h4 className="text-blue-900">Uploaded Documents</h4>
                  </div>
                ) : (
                  ""
                )}
                <div className="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 mt-2 gap-4">
                  {omsData?.loading_attachments?.length > 0 &&
                    omsData?.loading_attachments?.map((item, index) => {
                      return (
                        <>
                          <Card
                            sx={{
                              width: ["100%", "100%", "100%", "100%"],
                              bgcolor: "background.paper",
                              boxShadow: 24,
                              borderRadius: 4,
                              maxHeight: 300,
                              overflow: "auto",
                              backgroundColor: "#FEFEFE",
                            }}
                          >
                            <div className="flex justify-between m-2 mb-2">
                              <h5 className="text-center mt-2">
                                {" "}
                                {item?.type} Document
                              </h5>
                              <div className="flex justify-center">
                                <h5 className="flex justify-between  text-teal-700 mt-2 ">
                                  <Button
                                  // onClick={() =>
                                  //   downloadPDF(
                                  //     item?.url,
                                  //     `${new Date().toLocaleDateString()}_${
                                  //       item?.type
                                  //     }`
                                  //   )
                                  // }
                                  >
                                    <FileDownloadIcon
                                      icon="subway:download-1"
                                      width="24"
                                      height="24"
                                      className="ms-3"
                                      role="button"
                                    />
                                    <a
                                      style={{
                                        textDecoration: "none",
                                        color: "inherit",
                                      }}
                                      href={item?.url}
                                    >
                                      Download
                                    </a>
                                  </Button>
                                </h5>
                              </div>
                              <Button
                                onClick={() => handleModalOpen(item?.url)}
                              >
                                {" "}
                                View
                              </Button>
                            </div>

                            <div className=" flex justify-center border-2 mt-4 pb-5 border-b-teal-900  p-3">
                              {item?.url?.includes(".pdf") ? (
                                <Document
                                  maxHeight={200}
                                  maxWidth={300}
                                  file={item?.url}
                                  onLoadSuccess={onDocumentLoadSuccess}
                                  onLoadError={(error) =>
                                    console.error(
                                      "Error while loading document!",
                                      error
                                    )
                                  }
                                >
                                  <Page pageNumber={pageNumber} />
                                </Document>
                              ) : (
                                <img src={item?.url} alt="" />
                              )}
                            </div>
                            <div className="flex justify-between mt-1 pb-3">
                              <p className="">
                                Page {pageNumber || (numPages ? 1 : "--")} of{" "}
                                {numPages || "--"}
                              </p>
                              <div className="flex gap-2">
                                <Button
                                  size="small"
                                  variant="contained"
                                  disabled={pageNumber <= 1}
                                  onClick={previousPage}
                                  sx={{ backgroundColor: "#040D43" }}
                                >
                                  Previous
                                </Button>
                                <Button
                                  size="small"
                                  className="ml-2"
                                  variant="contained"
                                  disabled={pageNumber >= numPages}
                                  onClick={nextPage}
                                  sx={{ backgroundColor: "#040D43" }}
                                >
                                  Next
                                </Button>
                              </div>
                            </div>
                          </Card>
                        </>
                      );
                    })}
                </div>
                {/* {supplierDoc?.length > 0 && <h2>New files to upload</h2>} */}
                {/* <div className="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 mt-2 gap-4">
                  {supplierDoc?.length > 0
                    ? supplierDoc?.map((item, index) => {
                        {
                          console.log(item);
                        }
                        return (
                          <>
                            <Card
                              sx={{
                                width: ["100%", "100%", "90%", "100%"],
                                bgcolor: "background.paper",
                                boxShadow: 24,
                                borderRadius: 2,
                                maxHeight: 300, // Adjusted maxHeight
                                overflow: "auto",
                                overflowX: "hidden", // Added overflowX to hide horizontal scroll
                                backgroundColor: "#FEFEFE",
                              }}
                            >
                              <div className="flex justify-between m-2 mb-2">
                                <h5 className="text-center mt-2">
                                  {" "}
                                  {item?.type} Document
                                </h5>
                              </div>

                              <div className=" flex justify-center border-2 mt-4 pb-5 border-b-teal-900  p-3">
                                {item?.url?.includes(".pdf") ? (
                                  <Document
                                    maxHeight={200}
                                    file={item?.url}
                                    onLoadSuccess={onDocumentLoadSuccess}
                                    onLoadError={(error) =>
                                      console.error(
                                        "Error while loading document!",
                                        error
                                      )
                                    }
                                  >
                                    <Page pageNumber={pageNumber} />
                                  </Document>
                                ) : (
                                  <img src={item?.url} alt="" />
                                )}
                              </div>
                              <div className="flex justify-between mt-5 pb-3">
                                <p className="">
                                  Page {pageNumber || (numPages ? 1 : "--")} of{" "}
                                  {numPages || "--"}
                                </p>
                                <div className="flex gap-2">
                                  <Button
                                    size="small"
                                    variant="contained"
                                    disabled={pageNumber <= 1}
                                    onClick={previousPage}
                                    sx={{ backgroundColor: "#040D43" }}
                                  >
                                    Previous
                                  </Button>
                                  <Button
                                    size="small"
                                    className="ml-2"
                                    variant="contained"
                                    disabled={pageNumber >= numPages}
                                    onClick={nextPage}
                                    sx={{ backgroundColor: "#040D43" }}
                                  >
                                    Next
                                  </Button>
                                </div>
                              </div>
                            </Card>
                          </>
                        );
                      })
                    : ""}
                </div> */}
                <div className="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-1 lg:grid-cols-1 gap-3 mt-2 ">
                  <div>
                    <label
                      for="branch"
                      className="block mb-2 text-sm font-medium text-blue-900 dark:text-white flex justify-start ms-1"
                    >
                      Add Documents
                    </label>
                    <Button
                      sx={{ backgroundColor: "gray" }}
                      variant="contained"
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      onClick={() => handleOpenDoc()}
                      disabled={isPending}
                    >
                      <CloudUploadIcon />
                      <b className="ms-2 mt-1">Upload Documents</b>
                    </Button>
                  </div>
                </div>
                <div className="flex justify-end mt-2 gap-2">
                  <Button
                    color="error"
                    variant="contained"
                    size="small"
                    onClick={(e) => formik.resetForm()}
                    disabled={isPending}
                  >
                    CLEAR
                  </Button>
                  <Button
                    variant="contained"
                    size="small"
                    type="submit"
                    sx={{ backgroundColor: "#0D9223" }}
                    disabled={isPending}
                  >
                    SAVE
                  </Button>
                </div>
              </form>
            </div>
          )}
        </div>
      </div>
      <UploadDocs
        open={openDoc}
        handleClose={handleCloseDoc}
        handleAddObject={handleAddObject}
      />
      <AddLoadingDetails open={open} handleClose={handleClose} />

      <Modal
        open={activeModal}
        onClose={handleModalClose}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
      >
        <Box
          sx={{
            position: "absolute",
            width: "50%",
            height: "80%",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 4,
            overflowY: "auto",
          }}
        >
          <div className="">
            <IconButton
              aria-label="close"
              style={{ position: "absolute", right: "8px", top: "8px" }}
              onClick={() => handleModalClose()}
            >
              <CloseIcon />
            </IconButton>
          </div>
          <div className="flex flex-col items-center justify-center space-y-5 h-full">
            {pdfUrl?.toLowerCase().endsWith(".pdf") ? (
              <ShowPDF pdfUrl={pdfUrl} />
            ) : (
              <img src={pdfUrl} alt="uploaded image" />
            )}
          </div>
        </Box>
      </Modal>
    </div>
  );
}

export default LoadingDetailsSupplierForm;
